class FiftyFifty extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.card.elements.forEach((cardEl) => {
      this.listeners.add(cardEl, 'mouseover', this.handleTrigger)
    })

    if (window.BAO.MediaBreakpoints.isMd) return

    if (!this?.els?.['mobile-video']?.exists) return

    this.observer = new IntersectionObserver(
      this.onMobileVideoEntry.bind(this),
      {
        threshold: 0.5,
      },
    )

    this.els['mobile-video'].elements.forEach((videoEl) =>
      this.observer.observe(videoEl),
    )
  }

  onMobileVideoEntry ([entry]) {
    if (entry.isIntersecting) {
      entry.target.play()
    } else {
      entry.target.pause()
    }
  }

  handleTrigger (event) {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const hoveredCardEl = event.target.closest(this.els?.card?.selector)

    this.els.card.elements.forEach((cardEl) => {
      cardEl.classList.toggle(
        'sec-FiftyFifty_Card-active',
        cardEl === hoveredCardEl,
      )
    })

    if (this?.els?.['desktop-video']?.exists) {
      this.els['desktop-video'].elements.forEach((videoEl) => {
        const parentCardEl = videoEl.closest(this.els?.card?.selector)

        if (parentCardEl && hoveredCardEl) {
          const shouldAutoplay = parentCardEl === hoveredCardEl
          videoEl.toggleAttribute('autoplay', shouldAutoplay)

          if (shouldAutoplay) {
            videoEl.play()
          } else {
            videoEl.pause()
          }
        }
      })
    }
  }
}

if (!customElements.get('fifty-fifty')) {
  customElements.define('fifty-fifty', FiftyFifty)
}
